export const SEC_PER_MIN = 60
export const MILLI_PER_SEC = 1000
export const REGEX_EMOJI =
  /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g
